<template>
  <v-dialog v-model="visible" persistent max-width="400" overlay-opacity="0.8">
    <v-card class="card-shadow border-radius-xl">
      <v-card-text class="text-center py-8">
        <div class="mb-6">
          <v-progress-circular
            :size="60"
            :width="4"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-progress-linear
          indeterminate
          color="primary"
          height="4"
          rounded
          class="mb-4"
        ></v-progress-linear>

        <p class="text-body-1 text-typo mb-0">
          {{ message }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProgressDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 0 auto;
}
</style>
